import { useState } from "react";
import { Link } from "react-router-dom";
import { motion, useMotionValueEvent, useScroll } from "framer-motion";
import { Logo } from "./Logo";
import { scrollToId } from "./SmoothScroll";

const links = [
  ["how", "How it works"],
  ["box", "The box"],
  ["faq", "FAQ"],
];

export const Nav = () => {
  const { scrollY } = useScroll();
  const [solid, setSolid] = useState(false);
  useMotionValueEvent(scrollY, "change", (v) => setSolid(v > 40));

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.9, delay: 0.2, ease: [0.16, 1, 0.3, 1] }}
      className={`fixed inset-x-0 top-0 z-50 transition-[background-color,border-color] duration-500 ${
        solid ? "border-b border-[#1B2A1C]/10 bg-[#FBF7EE]/80 backdrop-blur-xl" : "border-b border-transparent"
      }`}
      data-testid="site-nav"
    >
      <div className="mx-auto flex max-w-[1440px] items-center justify-between px-5 py-4 sm:px-10">
        <Link to="/" className="flex items-center gap-2.5" data-testid="nav-logo">
          <Logo />
          <span className="font-display text-xl font-extrabold tracking-tight">Go Box</span>
        </Link>
        <nav className="hidden items-center gap-9 md:flex">
          {links.map(([id, label]) => (
            <button key={id} onClick={() => scrollToId(id)} className="link-underline text-sm text-[var(--sage)] hover:text-white" data-testid={`nav-link-${id}`}>
              {label}
            </button>
          ))}
        </nav>
        <button onClick={() => scrollToId("order")} className="btn-gold px-5 py-2.5 text-sm" data-testid="nav-order-button">
          Order a box
        </button>
      </div>
    </motion.header>
  );
};
